import api from "./axios";

// Public
export const getServices = () => api.get("/api/services/");
export const getService = (slug) => api.get(`/api/services/${slug}/`);

// Admin - Services
export const adminGetServices = () => api.get("/api/admin/services/");
export const adminGetService = (id) => api.get(`/api/admin/services/${id}/`);
export const adminGetServiceById = (id) => api.get(`/api/admin/services/${id}/`);
export const adminCreateService = (data) => api.post("/api/admin/services/", data, {
  headers: { "Content-Type": "multipart/form-data" },
});
export const adminUpdateService = (id, data) => api.put(`/api/admin/services/${id}/`, data);
export const adminDeleteService = (id) => api.delete(`/api/admin/services/${id}/`);

// Admin - Service Categories
export const adminGetServiceCategories = () => api.get("/api/admin/service-categories/");
export const adminGetServiceCategoryById = (id) => api.get(`/api/admin/service-categories/${id}/`);
export const adminCreateServiceCategory = (data) => api.post("/api/admin/service-categories/", data);
export const adminUpdateServiceCategory = (id, data) => api.put(`/api/admin/service-categories/${id}/`, data);
export const adminDeleteServiceCategory = (id) => api.delete(`/api/admin/service-categories/${id}/`);